import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import axios from 'axios';
import { toast } from '../../lib/toast';
import { API, auth, errMsg, Field, PrimaryBtn, inputCls } from '../organization/finance/shared';
import PaymentSettingsCard from '../organization/venue-booking/PaymentSettingsCard';

export default function VenueOwnerSettingsPage() {
  const { club } = useOutletContext();
  const [form, setForm] = useState({ name: club?.name || '', phone: club?.phone || '', city: club?.city || '' });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await axios.patch(`${API}/saas/venue-owner/profile`, form, auth());
      toast.success('تم حفظ التعديلات');
    } catch (e) { toast.error(errMsg(e, 'فشل حفظ التعديلات')); } finally { setSaving(false); }
  };

  return (
    <div className="max-w-xl space-y-4" data-testid="venue-owner-settings-page">
      <div className="rounded-2xl border border-slate-200 bg-white p-5 space-y-4">
        <p className="text-sm font-bold text-slate-700">بيانات الملعب/النشاط</p>
        <Field label="اسم الملعب / النشاط"><input className={inputCls} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="venue-owner-settings-name" /></Field>
        <Field label="رقم الجوال (واتساب)"><input dir="ltr" className={inputCls} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="venue-owner-settings-phone" /></Field>
        <Field label="المدينة"><input className={inputCls} value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} data-testid="venue-owner-settings-city" /></Field>
        <Field label="البريد الإلكتروني"><input disabled className={`${inputCls} bg-slate-100 text-slate-400`} value={club?.email || ''} data-testid="venue-owner-settings-email" /></Field>
        <PrimaryBtn onClick={save} disabled={saving} data-testid="venue-owner-settings-save-btn">{saving ? 'جارٍ الحفظ...' : 'حفظ التعديلات'}</PrimaryBtn>
      </div>
      <PaymentSettingsCard />
    </div>
  );
}
